import { ReactNode } from 'react'

import { useRouter } from 'next/router'

import CommonLayout from '@/components/layouts/common/Layout'
import Navbar from '@/components/layouts/home/Navbar'

interface LayoutProps {
  children: ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const router = useRouter()
  if (router.query.initialize === 'true') {
    return <>{children}</>
  }
  return <CommonLayout navbar={Navbar}>{children}</CommonLayout>
}

export const getLayout = (page: ReactNode) => <Layout>{page}</Layout>

export default Layout
